// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileMenu_wrapper__7yrPM","noScroll":"MobileMenu_noScroll__s3u-C","fon":"MobileMenu_fon__mL4wh"};